"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var date_fns_1 = require("date-fns");
var React = __importStar(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var informationModal_1 = __importDefault(require("./informationModal"));
exports.default = (function (props) {
    var availablePatterns = props.availablePatterns, promoProduct = props.promoProduct, modalHeader = props.modalHeader, modalText = props.modalText;
    var _a = __read(React.useState(''), 2), firstName = _a[0], setFirstName = _a[1];
    var _b = __read(React.useState(''), 2), lastName = _b[0], setLastName = _b[1];
    var _c = __read(React.useState(''), 2), email = _c[0], setEmailAddress = _c[1];
    var _d = __read(React.useState(null), 2), dueDate = _d[0], setDueDate = _d[1];
    var _e = __read(React.useState(''), 2), gender = _e[0], setGender = _e[1];
    var _f = __read(React.useState(''), 2), size = _f[0], setSize = _f[1];
    var _g = __read(React.useState(false), 2), disabledButton = _g[0], setDisabled = _g[1];
    var _h = __read(React.useState('pointer'), 2), cursorStyle = _h[0], setCursorStyle = _h[1];
    var _j = __read(React.useState(false), 2), isModalOpen = _j[0], setIsModalOpen = _j[1];
    var _k = __read(React.useState('Get Your Diapers'), 2), buttonText = _k[0], setButtonText = _k[1];
    var bundleId = new Date().getTime().toString();
    var privacyPolicyNotice = (React.createElement("div", { className: 'text-gray font-italic' },
        "**By signing up, you agree to our Privacy Policy and Terms of Use. For all the giveaway rules,",
        React.createElement("a", { href: '/pages/freediaperterms', className: 'padding-left-1' }, "click here"),
        "."));
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _learnq, pattern, mainProductVariant;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setDisabled(true);
                    setCursorStyle('not-allowed');
                    setButtonText('Redirecting to checkout...');
                    _learnq = window._learnq;
                    if (_learnq) {
                        _learnq.push([
                            'identify',
                            {
                                $email: email,
                                $first_name: firstName,
                                $last_name: lastName,
                            },
                        ]);
                        _learnq.push([
                            'track',
                            'Added New Mom Diaper Giveaway To Cart',
                            {
                                dueDate: (0, date_fns_1.format)(dueDate, 'yyyy-MM-dd'),
                                gender: gender,
                                size: size,
                            },
                        ]);
                    }
                    pattern = availablePatterns.filter(function (variant) { return variant.option1 === size; });
                    mainProductVariant = promoProduct.variants.filter(function (variant) { return variant.option1 === size; });
                    return [4 /*yield*/, window.cartApp.add([
                            [mainProductVariant[0].id, { properties: { bundle_id: bundleId }, quantity: 1 }],
                            [pattern[0].id, { properties: { parent_bundle_id: bundleId }, quantity: 1 }],
                        ], { redirectToCheckout: true })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: 'padding-vertical-5' },
        React.createElement("form", { onSubmit: handleSubmit },
            React.createElement("div", { className: 'grid-x' },
                React.createElement("div", { className: 'small-12 medium-6 text-gray', style: { fontSize: '10px' } },
                    "FIRST NAME",
                    React.createElement("div", { className: 'padding-right-4' },
                        React.createElement("input", { type: 'text', onChange: function (e) { return setFirstName(e.target.value); }, placeholder: 'First Name', required: true }))),
                React.createElement("div", { className: 'small-12 medium-6 text-gray', style: { fontSize: '10px' } },
                    "LAST NAME",
                    React.createElement("div", { className: 'padding-right-4' },
                        React.createElement("input", { type: 'text', onChange: function (e) { return setLastName(e.target.value); }, placeholder: 'Last Name', required: true })))),
            React.createElement("div", { className: 'text-gray', style: { fontSize: '10px' } }, "EMAIL"),
            React.createElement("div", { className: 'padding-right-4' },
                React.createElement("input", { type: 'email', onChange: function (e) { return setEmailAddress(e.target.value); }, placeholder: 'Email Address', required: true })),
            React.createElement("div", { className: 'grid-x' },
                React.createElement("div", { className: 'small-6 medium-4 text-gray', style: { fontSize: '10px' } },
                    "DUE DATE/BABY BIRTHDAY",
                    React.createElement("div", { className: 'padding-right-4' },
                        React.createElement(react_datepicker_1.default, { maxDate: (0, date_fns_1.addYears)(new Date(), 1), onChange: function (deliveryDate) { return setDueDate(deliveryDate); }, placeholderText: 'Due Date', selected: dueDate, required: true }))),
                React.createElement("div", { className: 'small-6 medium-4 text-gray', style: { fontSize: '10px' } },
                    "BABY'S GENDER",
                    React.createElement("div", { className: 'padding-right-5' },
                        React.createElement("select", { required: true, name: 'Gender', value: gender, onChange: function (e) {
                                setGender(e.target.value);
                            }, style: { display: 'block' } },
                            React.createElement("option", { value: '' }, "Gender"),
                            React.createElement("option", { value: 'male' }, "Male"),
                            React.createElement("option", { value: 'female' }, "Female"),
                            React.createElement("option", { value: 'prefer_not_say' }, "Prefer not to say")))),
                React.createElement("div", { className: 'small-12 medium-4 text-gray', style: { fontSize: '10px' } },
                    "DIAPER SIZE",
                    React.createElement("div", { className: 'padding-right-4' },
                        React.createElement("select", { required: true, name: 'Diaper Size', value: size, onChange: function (e) {
                                setSize(e.target.value);
                            }, style: { display: 'block' } },
                            React.createElement("option", { value: '' }, "Diaper Size"),
                            availablePatterns.map(function (pattern, i) {
                                // this will need to change if we add more than size N and 1
                                return pattern.option1 === 'N' ? (React.createElement("option", { key: i, value: pattern.option1 },
                                    "Size ",
                                    pattern.option1,
                                    " ",
                                    pattern.option2,
                                    " (up to 10lbs)")) : (React.createElement("option", { key: i, value: pattern.option1 },
                                    "Size ",
                                    pattern.option1,
                                    " ",
                                    pattern.option2,
                                    " (8 to 12lbs)"));
                            }))))),
            React.createElement("div", null, privacyPolicyNotice),
            React.createElement("div", { className: 'padding-top-10' },
                React.createElement("button", { className: (0, classnames_1.default)("bg-".concat(disabledButton ? 'gray' : 'light-wisteria', " text-white text-center width-50 padding-vertical-4")), disabled: disabledButton, type: 'submit', style: { cursor: cursorStyle } }, buttonText))),
        React.createElement("div", { className: 'padding-top-3' },
            React.createElement("button", { className: 'text-gray text-underline', style: { background: 'none', border: 'none' }, onClick: function () {
                    setIsModalOpen(true);
                } }, "WHY DO YOU NEED MY INFORMATION?")),
        React.createElement(informationModal_1.default, { isOpen: isModalOpen, handleClose: function () { return setIsModalOpen(false); }, modalHeader: modalHeader, modalText: modalText })));
});
